import React, { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'

import FontAwesome from 'components/FontAwesome'
import Button from 'components/elements/Button'
import { StyledSpan } from 'components/Layout/Header/styles'

import { StyledErrorMsg, StyledSuccessMsg, FormContainer, Input, SubmitButton } from './styles'

export default function NewslettrerForm({ placeholder, type = 'newsletter', buttonText }) {
   const [isLoading, handleIsLoading] = useState(false)
   const [isSuccess, handleIsSuccess] = useState(false)
   const [isFocused, setIsFocused] = useState(false)
   const timer = useRef()

   const {
      register,
      handleSubmit,
      setError,
      reset,
      formState: { errors },
      watch,
   } = useForm()

   const email = watch('email')

   async function signInToNewsletter(data) {
      handleIsLoading(true)

      await fetch('/.netlify/functions/newsletter', {
         method: 'POST',
         body: JSON.stringify({ ...data, type }),
      })
         .then((response) => response.json())
         .then((response) => {
            if (response.success) {
               handleIsSuccess(true)
               reset()
            } else {
               const errorMessage = Array.isArray(response.errors) 
                  ? response.errors.join(', ')
                  : response.errors || 'Unknown error'
               setError('email', { 
                  type: 'API', 
                  message: `Subscription failed: ${errorMessage}` 
               })
            }
         })
         .catch((err) => {
            console.error('Newsletter submission error:', err)
            setError('email', { 
               type: 'API', 
               message: 'Failed to submit. Please try again later.' 
            })
         })
         .finally(() => {
            handleIsLoading(false)
         })
   }

   useEffect(() => {
      if (isSuccess) {
         timer.current = setTimeout(() => {
            handleIsSuccess(false)
         }, 3000)
      }

      return () => {
         clearTimeout(timer.current)
      }
   }, [isSuccess])

   return (
      <div>
         <FormContainer
            onSubmit={handleSubmit(signInToNewsletter)}
            $isFocused={isFocused}
            $isFilled={email?.length > 0}
            $hasButtonText={!!buttonText}
         >
            {buttonText ? (
               <>
                  <div className="input-wrapper">
                     <FontAwesome className="icon" icon="emailOutline" />
                     <Input
                        type="email"
                        placeholder={placeholder}
                        onFocus={() => setIsFocused(true)}
                        {...register('email', {
                           required: { value: true, message: 'This field is required' },
                           pattern: {
                              value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                              message: 'Invalid email address',
                           },
                           onBlur: () => setIsFocused(false),
                        })}
                     />
                  </div>
                  <Button 
                     type="submit" 
                     disabled={isLoading}
                     variant="orange"
                     style={{ width: '100%' }}
                  >
                     <StyledSpan>{buttonText}</StyledSpan>
                  </Button>
               </>
            ) : ( 
               <>
                  <FontAwesome className="icon" icon="emailOutline" />
                  <Input
                     type="email"
                     placeholder={placeholder}
                     onFocus={() => setIsFocused(true)}
                     {...register('email', {
                        required: { value: true, message: 'This field is required' },
                        pattern: {
                           value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                           message: 'Invalid email address',
                        },
                        onBlur: () => setIsFocused(false),
                     })}
                  />
                  <SubmitButton type="submit" disabled={isLoading} role="button" aria-label="Sign in to newsletter" style={{ opacity: email?.length > 0 ? 1 : 0.5, pointerEvents: email?.length > 0 ? 'auto' : 'none' }}>
                     <FontAwesome icon={'arrowRight'} />
                  </SubmitButton>
               </>
            )}
         </FormContainer>

         {errors.email && <StyledErrorMsg>{errors.email.message}</StyledErrorMsg>}
         {isSuccess && <StyledSuccessMsg>Successfully signed up</StyledSuccessMsg>}
      </div>
   )
}
